import React, { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ReactPaginate from "react-paginate";

import { UseGetLibrary } from "core/services/api/get-library";
import { correctUploadPath } from "core/utils/image-path-correction";
import LibraryItem from "components/common/LibraryItem";
import SkeletonCard from "./SkeletonCard/SkeletonCard";

import "./LibraryList.scss";

const LibraryList = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 12;

  const { data, isLoading, isError, mutate } = UseGetLibrary();

  useEffect(() => {
    mutate({ page: pageNumber, pageSize });
  }, [pageNumber]);

  const books = data?.data?.result?.item || [];
  const totalCount = data?.data?.result?.totalCount || 0;
  const pageCount = Math.ceil(totalCount / pageSize);
  const iconStyle = { color: "#0B1803", fontSize: "24px" };

  if (isLoading) {
    return (
      <div className="library-list-container">
        <h1 className="library-list-title"> کتابخانه </h1>
        <div className="library-grid">
          {Array.from({ length: pageSize }).map((_, idx) => (
            <SkeletonCard key={idx} />
          ))}
        </div>
      </div>
    );
  }

  if (isError) {
    return <div className="library-list-empty"> خطا در دریافت کتابخانه</div>;
  }

  return (
    <div className="library-list-container">
      <h1 className="library-list-title"> کتابخانه</h1>
      {books.length === 0 ? (
        <p className="library-list-empty">هیچ کتابی یافت نشد</p>
      ) : (
        <>
          <div className="library-grid">
            {books.map((book) => (
              <LibraryItem
                key={book.id}
                id={book.id}
                image={correctUploadPath(book.imageThumbnail)}
                title={book.title}
                description={book.description}
                bookData={book}
              />
            ))}
          </div>

          {pageCount > 1 && (
            <div className="pagination-wrapper">
              <ReactPaginate
                previousLabel={
                  <span>
                    <IoIosArrowForward style={iconStyle} />
                  </span>
                }
                nextLabel={
                  <span>
                    <IoIosArrowBack style={iconStyle} />
                  </span>
                }
                breakLabel="..."
                breakClassName="break-me"
                pageCount={pageCount}
                containerClassName="pagination-holder"
                activeClassName="page-active"
                forcePage={pageNumber - 1}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                onPageChange={({ selected }) => setPageNumber(selected + 1)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export { LibraryList };
